<template><div><h1>VUX V2.1.1Rc.8 released</h1>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] Update header style and add less variables</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] Support slot:active-icon</li>
</ul>
<h2><a href="/en/components/x-header.html">XHeader</a></h2>
<ul><li>[fix] Fix transition</li>
<li>[fix] Fix back-text i18n</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] Support prop:placeholder-align</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] support title prop</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.8 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.8-97.vue?518a8698